export default (price) => {
  return price ? (price * 1).toLocaleString('us') : '';
}
